<template>
  <v-row justify="center" align="center">
    <v-col cols="12" md="11" style="padding: 0px">

      <v-row class="d-flex" style="display: flex; justify-content: flex-end;">
        <!-- Filtros -->
        <v-chip-group v-model="selectedFilters">
          <!-- Estado -->
          <v-menu offset-y bottom right v-if="pin_state && filters['state']">
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on" closeable @click:close="resetAllFilters">
                <template v-if="selectedState && selectedState.name">
                  <v-avatar
                      left
                      width="62"
                      class="white darken-4"
                  >
                    {{ selectedState.count || ''}}
                  </v-avatar>
                  <div class="chiptext">{{ selectedState.name }}</div>
                </template>
                <template v-else>
                  Estado
                </template>
                <v-icon>mdi-chevron-down</v-icon>
              </v-chip>
            </template>
            <div style="max-height: 300px; overflow-y: auto;">
            <v-list dense>
              <v-list-item-group>
                <v-list-item
                    v-for="(state, index) in filters['state'].user_values"
                    :key="index"
                    @click="updateState(state)"
                >
                  <v-list-item-title>
                    {{ state.text }}
                  </v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            </div>
          </v-menu>
          <v-divider vertical v-if="pin_state"></v-divider>
          <!-- Añadir filtro btn -->
          <app-search-add-filter-btn
              ref="addFilterBtn"
              :filters="mainFilters"
              :conditions="conditions"
              @updateObject="updateObject"
              @remove-filter="removeFilter"
              @add-filter="addFilter"
              :initial_filters="initial_filters"
          />
          <!-- Reset BTN -->
          <v-chip v-if="show_delete_filters" @click="resetAllFilters" closeable>
            <AppIcon :src="require(`@/assets/delete-filters.svg`)" :size="24" :colorMap="{ '#D9D9D9': '#D9D9D9' }"/>
            <span>{{$t("AppSearchAddFilterBtn.delete_filters")}}</span>
          </v-chip>
        </v-chip-group>
        <!-- End Filtros -->
      </v-row>
    </v-col>
  </v-row>
</template>


<script>
import {mapGetters, mapState} from "vuex";
// import {mapFields} from "vuex-map-fields";
// import {vuexPrefix, vuexPrefix2} from "@/store/vuex_utils";
import AppDatePicker from "@/components/layout/AppDatePicker.vue";
import AppSearchAddFilterBtn from "@/components/layout/AppSearchAddFilterBtn.vue";

export default {
  name: "AppSearchBar",
  components: {
    AppSearchAddFilterBtn,
    AppDatePicker,
  },
  data() {
    return {
      selectedFilters: [], // Filtros seleccionados
      selectedState: null, // Estado seleccionado actualmente
      menu: false,
    };
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    conditions:{
      type: Object,
      required: false,
    },
    pin_state: {
      type: Boolean,
      default: false,
    },
    initial_filters: {
      type: Array,
      default: () => ([]),
    },
    show_delete_filters: {
      type: Boolean,
      default: true,
    },
    filters_for: {
      required: false,
      type: String,
      default: ''
    }
  },  
  methods: {
    updateObject(data){
      let param = data.param
      let selected_filters = data.selected_filters
      if (
        this.filters_for == 'bank_transactions' &&
        param.key == 'possible_duplicates' &&
        selected_filters.length > 1 &&
        selected_filters[selected_filters.length - 1].name == 'possible_duplicates'
      ) {
        this.selectedState = null;
        this.selectedFilters = [];
        this.$refs.addFilterBtn.resetFilters(true)
        this.$refs.addFilterBtn.addFilter(this.filters['possible_duplicates'])
        this.$emit('updateObject',param)
        return;
      }
      this.$emit('updateObject',param)
    },
    updateState(state) {
      this.selectedState = state;
      this.selectedFilters = [state]; // O añade a la lista según necesidad
    },
    addFilter(filter) {
      this.$emit('addFilter',filter)
    },
    resetAllFilters() {
      this.selectedState = null;
      this.selectedFilters = [];
      this.$refs.addFilterBtn.resetFilters()
      this.$emit('resetAllFilters',{})
      
    },
    removeFilter(param){
      this.$emit('updateObject',{key:param,value:'',text:''})
    }

  },
  computed: {
    // Filtros sin "state" (fix_state)
    mainFilters() {
      if (this.pin_state && this.filters['state']){
        // return filters without state
        return Object.keys(this.filters).filter(f => f !== 'state').reduce((obj, key) => {
          obj[key] = this.filters[key];
          return obj;
        }, {});
      }
      return this.filters;
    },
    ...mapGetters({ 
      is_mobile: "is_mobile",
    }),
    
  }
};
</script>

<style scoped>
.chiptext {
  max-width: 80%;
}
</style>